import { render, staticRenderFns } from "./VeAspectRatioPicker.vue?vue&type=template&id=2b0a0f38&scoped=true"
import script from "./VeAspectRatioPicker.vue?vue&type=script&lang=js"
export * from "./VeAspectRatioPicker.vue?vue&type=script&lang=js"
import style0 from "./VeAspectRatioPicker.vue?vue&type=style&index=0&id=2b0a0f38&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b0a0f38",
  null
  
)

export default component.exports